import { COLOR_BACKGROUND_CARD_DARK, COLOR_BACKGROUND_BACKDROP_STRONG_DARK, COLOR_BACKGROUND_LEVEL_0_DARK, COLOR_BACKGROUND_LEVEL_1_DARK, COLOR_BACKGROUND_LEVEL_2_DARK, COLOR_BACKGROUND_LEVEL_3_DARK, COLOR_BASE_BRAND_BLACK, COLOR_BASE_BRAND_PROGRESSIVE_RED, COLOR_BASE_BRAND_WHITE, COLOR_BASE_CHARGING_NEON_BLUE_DARK, COLOR_BASE_GREY_0, COLOR_BASE_GREY_10, COLOR_BASE_GREY_100, COLOR_BASE_GREY_15, COLOR_BASE_GREY_20, COLOR_BASE_GREY_30, COLOR_BASE_GREY_40, COLOR_BASE_GREY_5, COLOR_BASE_GREY_50, COLOR_BASE_GREY_60, COLOR_BASE_GREY_70, COLOR_BASE_GREY_80, COLOR_BASE_GREY_90, COLOR_BASE_SIGNAL_GREEN_DARK, COLOR_BASE_SIGNAL_RED_DARK, COLOR_BASE_SIGNAL_YELLOW_DARK, COLOR_CHARGING_DEFAULT_DARK, COLOR_CHARGING_INTELLIGENT_DARK, COLOR_INTERACTION_LABEL_ACTIVE_DARK, COLOR_INTERACTION_LABEL_DEFAULT_DARK, COLOR_INTERACTION_LABEL_DISABLED_DARK, COLOR_INTERACTION_LABEL_FILLED_DARK, COLOR_INTERACTION_LABEL_FOCUS_DARK, COLOR_INTERACTION_LABEL_HOVER_DARK, COLOR_INTERACTION_LABEL_PRESSED_DARK, COLOR_INTERACTION_LABEL_READONLY_DARK, COLOR_INTERACTION_PRIMARY_ACTIVE_DARK, COLOR_INTERACTION_PRIMARY_DEFAULT_DARK, COLOR_INTERACTION_PRIMARY_DISABLED_DARK, COLOR_INTERACTION_PRIMARY_FOCUS_DARK, COLOR_INTERACTION_PRIMARY_HOVER_DARK, COLOR_INTERACTION_PRIMARY_PRESSED_DARK, COLOR_INTERACTION_SECONDARY_ACTIVE_DARK, COLOR_INTERACTION_SECONDARY_DEFAULT_DARK, COLOR_INTERACTION_SECONDARY_DISABLED_DARK, COLOR_INTERACTION_SECONDARY_FILLED_DARK, COLOR_INTERACTION_SECONDARY_FOCUS_DARK, COLOR_INTERACTION_SECONDARY_HOVER_DARK, COLOR_INTERACTION_SECONDARY_PRESSED_DARK, COLOR_INTERACTION_SECONDARY_READONLY_DARK, COLOR_INTERACTION_TERTIARY_ACTIVE_DARK, COLOR_INTERACTION_TERTIARY_DEFAULT_DARK, COLOR_INTERACTION_TERTIARY_DISABLED_DARK, COLOR_INTERACTION_TERTIARY_HOVER_DARK, COLOR_UI_DIVIDER_DARK, COLOR_UI_ERROR_DARK, COLOR_UI_HIGHLIGHT_PRIMARY_DARK, COLOR_UI_HIGHLIGHT_SECONDARY_DARK, COLOR_UI_HIGHLIGHT_TERTIARY_DARK, COLOR_UI_INVERTED_DARK, COLOR_UI_PENDING_DARK, COLOR_UI_PRIMARY_DARK, COLOR_UI_SECONDARY_DARK, COLOR_UI_SUCCESS_DARK, COLOR_UI_TERTIARY_DARK, } from "@audi/audi-ui-design-tokens";
export const colors = {
    base: {
        brand: {
            white: COLOR_BASE_BRAND_WHITE,
            black: COLOR_BASE_BRAND_BLACK,
            progressiveRed: COLOR_BASE_BRAND_PROGRESSIVE_RED,
        },
        grey: {
            0: COLOR_BASE_GREY_0,
            5: COLOR_BASE_GREY_5,
            10: COLOR_BASE_GREY_10,
            15: COLOR_BASE_GREY_15,
            20: COLOR_BASE_GREY_20,
            30: COLOR_BASE_GREY_30,
            40: COLOR_BASE_GREY_40,
            50: COLOR_BASE_GREY_50,
            60: COLOR_BASE_GREY_60,
            70: COLOR_BASE_GREY_70,
            80: COLOR_BASE_GREY_80,
            90: COLOR_BASE_GREY_90,
            100: COLOR_BASE_GREY_100,
        },
        signal: {
            green: COLOR_BASE_SIGNAL_GREEN_DARK,
            red: COLOR_BASE_SIGNAL_RED_DARK,
            yellow: COLOR_BASE_SIGNAL_YELLOW_DARK,
        },
        charging: {
            neonBlue: COLOR_BASE_CHARGING_NEON_BLUE_DARK,
            neonGreen: COLOR_BASE_CHARGING_NEON_BLUE_DARK,
        },
    },
    charging: {
        default: COLOR_CHARGING_DEFAULT_DARK,
        intelligent: COLOR_CHARGING_INTELLIGENT_DARK,
    },
    background: {
        level: {
            0: COLOR_BACKGROUND_LEVEL_0_DARK,
            1: COLOR_BACKGROUND_LEVEL_1_DARK,
            2: COLOR_BACKGROUND_LEVEL_2_DARK,
            3: COLOR_BACKGROUND_LEVEL_3_DARK,
        },
        card: COLOR_BACKGROUND_CARD_DARK,
        backdrop: {
            strong: COLOR_BACKGROUND_BACKDROP_STRONG_DARK,
        },
    },
    interaction: {
        primary: {
            default: COLOR_INTERACTION_PRIMARY_DEFAULT_DARK,
            hover: COLOR_INTERACTION_PRIMARY_HOVER_DARK,
            active: COLOR_INTERACTION_PRIMARY_ACTIVE_DARK,
            disabled: COLOR_INTERACTION_PRIMARY_DISABLED_DARK,
            focus: COLOR_INTERACTION_PRIMARY_FOCUS_DARK,
            pressed: COLOR_INTERACTION_PRIMARY_PRESSED_DARK,
        },
        secondary: {
            default: COLOR_INTERACTION_SECONDARY_DEFAULT_DARK,
            hover: COLOR_INTERACTION_SECONDARY_HOVER_DARK,
            active: COLOR_INTERACTION_SECONDARY_ACTIVE_DARK,
            filled: COLOR_INTERACTION_SECONDARY_FILLED_DARK,
            disabled: COLOR_INTERACTION_SECONDARY_DISABLED_DARK,
            focus: COLOR_INTERACTION_SECONDARY_FOCUS_DARK,
            readonly: COLOR_INTERACTION_SECONDARY_READONLY_DARK,
            pressed: COLOR_INTERACTION_SECONDARY_PRESSED_DARK,
        },
        tertiary: {
            default: COLOR_INTERACTION_TERTIARY_DEFAULT_DARK,
            hover: COLOR_INTERACTION_TERTIARY_HOVER_DARK,
            active: COLOR_INTERACTION_TERTIARY_ACTIVE_DARK,
            disabled: COLOR_INTERACTION_TERTIARY_DISABLED_DARK,
        },
        label: {
            default: COLOR_INTERACTION_LABEL_DEFAULT_DARK,
            hover: COLOR_INTERACTION_LABEL_HOVER_DARK,
            active: COLOR_INTERACTION_LABEL_ACTIVE_DARK,
            filled: COLOR_INTERACTION_LABEL_FILLED_DARK,
            disabled: COLOR_INTERACTION_LABEL_DISABLED_DARK,
            focus: COLOR_INTERACTION_LABEL_FOCUS_DARK,
            readonly: COLOR_INTERACTION_LABEL_READONLY_DARK,
            pressed: COLOR_INTERACTION_LABEL_PRESSED_DARK,
        },
    },
    ui: {
        primary: COLOR_UI_PRIMARY_DARK,
        secondary: COLOR_UI_SECONDARY_DARK,
        tertiary: COLOR_UI_TERTIARY_DARK,
        inverted: COLOR_UI_INVERTED_DARK,
        highlight: {
            primary: COLOR_UI_HIGHLIGHT_PRIMARY_DARK,
            secondary: COLOR_UI_HIGHLIGHT_SECONDARY_DARK,
            tertiary: COLOR_UI_HIGHLIGHT_TERTIARY_DARK,
        },
        divider: COLOR_UI_DIVIDER_DARK,
        error: COLOR_UI_ERROR_DARK,
        success: COLOR_UI_SUCCESS_DARK,
        pending: COLOR_UI_PENDING_DARK,
    },
};
//# sourceMappingURL=audi-colors.mjs.mjs.map